// extracted by mini-css-extract-plugin
export default {"itemWrapper":"style_itemWrapper__1sMM7","itemLabel":"style_itemLabel__8Tko3","itemValue":"style_itemValue__D6M4d"};